import React from 'react';

import { Typography } from '@mui/material';
import type { GridCellParams } from '@mui/x-data-grid-premium';
import type { WorkflowListGridRow } from 'src/components/workflow/workflow-list';
import {
  getIsWorkflowListGroupRow,
  getIsWorkflowListWorkflowRow,
} from 'src/components/workflow/workflow-list';
import { WorkflowListGroupLabelCell } from 'src/components/workflow/workflow-list/cells/WorkflowListGroupLabelCell';
import {
  getWorkflowTypeIcon,
  getWorkflowTypeLabel,
} from 'src/components/workflow/workflow-list/workflow-type';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  cell: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(0.75),
    maxWidth: '100%',
    minWidth: 0,
  },
  icon: {
    alignItems: 'center',
    color: theme.palette.text.secondary,
    display: 'flex',
    flexShrink: 0,
  },
  label: {
    color: theme.palette.text.primary,
    fontWeight: 500,
  },
}));

export function WorkflowListWorkflowTypeCell({
  field,
  row,
}: GridCellParams<WorkflowListGridRow>): JSX.Element | null {
  const { classes } = useStyles();
  if (getIsWorkflowListGroupRow(row)) {
    return (
      <WorkflowListGroupLabelCell count={row.workflowCount} field={field} label={row.groupLabel} />
    );
  }
  if (!getIsWorkflowListWorkflowRow(row)) return null;

  const sourceWorkflow = row.sourceWorkflow
    ? { id: row.sourceWorkflow.id, name: row.sourceWorkflow.name }
    : null;
  const Icon = getWorkflowTypeIcon(sourceWorkflow);
  const label = getWorkflowTypeLabel(sourceWorkflow);

  return (
    <div className={classes.cell}>
      <div className={classes.icon}>
        <Icon size={16} />
      </div>
      <Typography noWrap className={classes.label} variant="body2">
        {label}
      </Typography>
    </div>
  );
}
